import React, { useContext } from 'react';
import HeroDatosAbiertosWebp from '../../../medatatheme/assets/images/hero-datos-abiertos.webp';
import HeroDatosAbiertos from '../../../medatatheme/assets/images/hero-datos-abiertos.png';
import SearchFilterDropdown from '../SearchFilterDropdown';
import { defaultFacets } from '../../../config/search';
import { MedataContext } from '../../../ContexMedata';

// Hero de la home: imagen "Datos abiertos" (texto/sello quemados) + barra de
// búsqueda. Va en el flujo normal del <main>, NO dentro del <header> fijo, para
// no solapar el contenido (ver Opción A del rediseño).
const HomeHero = () => {
  const { datasetsL } = useContext(MedataContext);

  return (
    <div className="home-hero-wrapper">
      {/* Hero "Datos abiertos": imagen con texto y sello quemados.
          Se sirve WebP (~280KB) a los navegadores modernos y PNG como respaldo
          para los antiguos. La imagen original era un PNG de 8000px / 16.8MB;
          ahora va a 2560px de ancho, suficiente hasta pantallas 4K. */}
      <div className="home-hero">
        <picture>
          <source srcSet={HeroDatosAbiertosWebp} type="image/webp" />
          <img
            src={HeroDatosAbiertos}
            alt="Datos abiertos - Somos Distrito CT+I - Alcaldía de Medellín"
            width="2560"
            height="823"
          />
        </picture>
      </div>
      {/* Barra de búsqueda + contador de conjuntos de datos. */}
      <div className="home-hero-search">
        <p className="home-hero-count">
          Consulta y accede a <b>{datasetsL ? datasetsL : ''} conjunto(s)</b> de datos en línea
        </p>
        <div className="search-wrapper">
          <div className="search-container">
            <SearchFilterDropdown defaultFacets={defaultFacets} />
            <form action="/search/" method="get" className="search-form">
              <input
                type="text"
                placeholder="¿Qué datos buscas? Ej: parque automotor"
                className="search-input"
                name="fulltext"
              />
              <button className="search-button" type="submit">Buscar</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeHero;
